import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../../containers/common.duck';

const Snackbar = ({ text, isShown }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (isShown) {
      setTimeout(() => {
        dispatch(setSnackbar({ text: '', isOpen: false }));
      }, 5000);
    }
  }, [isShown]);
  return (
    <div className={`snackbar ${isShown && 'snackbar-open'}`}>
      <div className="snackbar_text">{text}</div>
      <div
        role="presentation"
        className="snackbar_close-btn"
        onClick={() => {
          dispatch(setSnackbar({ text: '', isOpen: false }));
        }}
        style={{
          maskImage: `url(${'https://reecommdev.blob.core.windows.net/re-assets/icons/close.svg'})`,
          WebkitMaskImage: `url(${'https://reecommdev.blob.core.windows.net/re-assets/icons/close.svg'})`
        }}
      />
    </div>
  );
};

Snackbar.propTypes = {
  text: PropTypes.string,
  isShown: PropTypes.bool,
  onClose: PropTypes.func
};

export default Snackbar;
